export default {
  title: "Soporte",
  payments: "Para todas las preguntas relacionadas con los pagos, por favor escriba a {finance_email}.",
  spam: 'Importante: ¡revise la carpeta de "Spam"!',
  other: "Para cualquier otra consulta, utilice el formulario a continuación.",
  faq: "preguntas frecuentes",
  faq_notice:
    "Antes de enviar una solicitud, revise nuestras reglas y la sección de {faq} (FAQ) — es posible que la respuesta ya esté allí.",
  response_time:
    "La respuesta puede tardar de 12 horas hasta 2 días laborables, según la complejidad de la solicitud y la carga actual del soporte."
};
